import React, { useEffect, useRef, useState } from 'react'
import { Imprimir, Voltar, BtnAcao, MinimizarDados } from './Acoes'
import ReactToPrint from 'react-to-print'
import { meses } from '../util/Utilitarios'
import { withRouter } from 'react-router-dom'
import '../assets/css/visualizacao.css'
import Interweave from 'interweave';
import { getUsuario } from '../util/Configuracoes'
import moment from 'moment'
import Modal from 'react-modal'
import { mostrarToast } from './Toasts'
import { mensagens } from '../util/Utilitarios'
import { ReservaRodapeHash, RodapeHash } from './RodapeHash'

const tipoGrupo = grupo => {
    const obj = {
        'tabela': <table className="table table-responsive-md table-visualizacao" >
            <thead>
                {grupo.thead}
            </thead>
            <tbody>
                {(grupo.tbody && grupo.tbody.length && grupo.tbody) || <tr><td className='div-center' colSpan={grupo.thead && grupo.thead.props.children.length}>Sem Registros!</td></tr>}
                {(grupo.aposGrupo ? grupo.aposGrupo : <></>)}
            </tbody>
        </table>,
        'medidor': (
            grupo.componente
        ),
        default: () => grupo.colunas && grupo.colunas.map((coluna, index) => coluna &&
            <div key={index} className={coluna.tamanho + ' col-sm-12 mb-20'}>
                <span className="data-title">{coluna.titulo}</span>
                {coluna.htmlDireto ? coluna.htmlDireto :
                    (coluna.html ? <Interweave content={coluna.descricao.toString()} /> : <span >{coluna.descricao}</span>)}
            </div>
        )
    }

    return obj[grupo.tipoGrupo] || obj.default()
}

const IMPRESSAO = { PRINCIPAL: 'principal', COM_ADICIONAL: 'com_adicional', SOMENTE_ADICIONAL: 'somente_adicional' }

// Escolha do que imprimir (ex.: só a guia ou a guia com os indicadores): botões do mesmo tamanho,
// empilhados, e largura que se ajusta à tela (funciona no celular)
const ModalOpcoesImpressao = ({ aberto, fechar, pergunta, textoPrincipal, textoAdicional, textoSomenteAdicional, escolher }) => {
    useEffect(() => { Modal.setAppElement('body') }, [])

    return (
        <Modal isOpen={aberto} onRequestClose={fechar} contentLabel="Imprimir" className='modal-opcoes-impressao' overlayClassName='modal-opcoes-impressao-fundo'>
            <div className='moi-cabecalho'>
                <b>Imprimir</b>
                <button type='button' className='moi-fechar' onClick={fechar} aria-label='Fechar'>&times;</button>
            </div>
            <div className='moi-corpo'>
                <span>{pergunta}</span>
                <button type='button' className='btn btn-outline-secondary moi-opcao' onClick={() => escolher(IMPRESSAO.PRINCIPAL)}>
                    <span className='icon-Printer' /> {textoPrincipal}
                </button>
                <button type='button' className='btn btn-primary primary moi-opcao' onClick={() => escolher(IMPRESSAO.COM_ADICIONAL)}>
                    <span className='icon-Files' /> {textoAdicional}
                </button>
                {textoSomenteAdicional ? <button type='button' className='btn btn-outline-secondary moi-opcao' onClick={() => escolher(IMPRESSAO.SOMENTE_ADICIONAL)}>
                    <span className='icon-File' /> {textoSomenteAdicional}
                </button> : <></>}
            </div>
        </Modal>
    )
}

const VisualizacaoPadrao = ({ bloqueioImpressao, ...props }) => {
    const user = getUsuario()
    const reference = useRef();
    const btnPrint = useRef();
    const actualDate = new Date();
    const data = props.data
    const [minimizar, setMinimizar] = useState([])
    // opcaoImpressao ({ pergunta, texto, textoSomente, carregar }): ao imprimir, pergunta se vai só a visualização,
    // ela com o conteúdo carregado (ex.: guia + indicadores pós-anestésicos), que sai em página nova, ou só o conteúdo
    const [perguntarImpressao, setPerguntarImpressao] = useState(false)
    const [extraImpressao, setExtraImpressao] = useState(null)
    const [somenteExtra, setSomenteExtra] = useState(false)
    const [imprimirPendente, setImprimirPendente] = useState(false)
    // hash de validação no rodapé de cada folha impressa
    const hash = data.hash_impressao

    const imprimir = () => props.opcaoImpressao ? setPerguntarImpressao(true) : btnPrint.current.click()

    const escolherImpressao = async (opcao) => {
        setPerguntarImpressao(false)
        try {
            setExtraImpressao(opcao !== IMPRESSAO.PRINCIPAL ? await props.opcaoImpressao.carregar() : null)
            setSomenteExtra(opcao === IMPRESSAO.SOMENTE_ADICIONAL)
            setImprimirPendente(true)
        } catch (e) {
            mostrarToast('erro', mensagens.erro)
        }
    }

    // imprime depois que o conteúdo adicional já está na tela
    useEffect(() => {
        if (!imprimirPendente)
            return
        setImprimirPendente(false)
        btnPrint.current.click()
    }, [imprimirPendente])

    // a área impressa é um bloco comum: o card (flex) não aceita quebra de página dentro dele
    return (
        <div ref={reference}>
        <RodapeHash hash={hash} />
        <div className={somenteExtra ? 'd-none-print' : ''}>
        <ReservaRodapeHash hash={hash}>
        <div className="card">
            <ReactToPrint
                trigger={() => <button className={"hidden d-none"} ref={btnPrint} />}
                content={() => reference.current} pageStyle={`@page { size: ${props.orientacao || 'a4 auto'} }`}
                onAfterPrint={() => { setExtraImpressao(null); setSomenteExtra(false) }} />
            {
                <div className="card-body">
                    <div className={'d-block-print'}>
                        <div className={'col-12 row mt-3'}>
                            <div className="col-8">
                                <h5>{data.titulo}</h5>
                                <h6>{actualDate.getDate().toString().padStart(2, '0') + ' de ' + (meses[actualDate.getMonth() + 1] || meses.default) + ' de ' + actualDate.getFullYear()}</h6>
                            </div>
                            <div className="col-4 text-right">
                                <img alt='logo' className="logo-menu" src={require('../assets/img/logo-menu.png')}></img>
                            </div>
                        </div>
                    </div>
                    <div className={'d-none-print colored'}>
                        <div className={'col-12 row mr-0 ml-0 mb-1 pr-0 pl-0'}>
                            <div className="col-12 row-space-between pr-0 pl-0">
                                <div>
                                    {/* <BtnAcao icone="icon-Arrow-Left" texto="Voltar" action={() => props.history.goBack()} /> */}
                                </div>
                                <div className="text-right">
                                    {bloqueioImpressao == true ? <></> : <Imprimir action={imprimir} />}
                                </div>
                            </div>
                            <div className="col-12 titulo-visualizacao">
                                <h5>{data.titulo}</h5>
                                <h6>{actualDate.getDate().toString().padStart(2, '0') + ' de ' + (meses[actualDate.getMonth() + 1] || meses.default) + ' de ' + actualDate.getFullYear()}</h6>
                            </div>
                        </div>
                    </div>
                    {data.grupos ? data.grupos.filter(x => x.visivel !== false).map((grupo, index, arrayAtual) => grupo &&
                        <div className={"dados-visualizacao " + (minimizar[index] === false ? "d-none-print" : "")} key={index}>

                            <div className="group-title row-space-between ">
                                <h5> {grupo.titulo} </h5>
                                {grupo.minimizar ? <div className='d-none-print'> <MinimizarDados className={"visualizacao " + (minimizar[index] === false ? "strikediag" : "")}
                                    texto={minimizar[index] === true || minimizar[index] === undefined ? "Esconder na Impressão " : "Mostrar na Impressão"} action={() => {
                                        if (minimizar.length > 0) {
                                            let cloneArray = [...minimizar]
                                            cloneArray[index] = !cloneArray[index]
                                            setMinimizar(cloneArray)
                                        } else {
                                            let cloneArray = Array(arrayAtual.length).fill(true)
                                            cloneArray[index] = false
                                            setMinimizar(cloneArray)
                                        }

                                    }

                                    } /> </div> : <></>}

                            </div>
                            <div className="row">
                                {tipoGrupo(grupo)}
                            </div>
                        </div>
                    ) : <div className="dados-visualizacao">
                        <div className="group-title">
                            <h5>Não há dados!</h5>
                        </div>
                    </div>}
                    {
                        props.visualizacaoAssinatura == true ?
                            <div className="group-title assinatura">
                                <span className='linha-assinatura'>
                                    <span>Responsável</span>
                                </span>
                            </div> :
                            <></>
                    }
                    <div className="footer-only-print-visualizacao">
                        <div className="col-md-12">
                            <span><i>Visualização Emitida <b>{user.nome}</b> no dia {moment().format('DD/MM/YYYY')} às {moment().format('HH:mm:ss')}</i></span>
                        </div>
                    </div>
                </div>
            }
            {props.opcaoImpressao ? <ModalOpcoesImpressao aberto={perguntarImpressao} fechar={() => setPerguntarImpressao(false)}
                pergunta={props.opcaoImpressao.pergunta} textoPrincipal={props.opcaoImpressao.textoPrincipal || 'Somente a guia'}
                textoAdicional={props.opcaoImpressao.texto} textoSomenteAdicional={props.opcaoImpressao.textoSomente}
                escolher={escolherImpressao} /> : <></>}
        </div>
        </ReservaRodapeHash>
        </div>
        {/* conteúdo adicional: só na impressão, em página própria (ou sozinho) e com a própria linha de emissão */}
        {extraImpressao ? <div className={'impressao-pagina-nova' + (somenteExtra ? ' impressao-sem-quebra' : '')}>
            <ReservaRodapeHash hash={hash}>
                {extraImpressao}
                <div className="footer-only-print-visualizacao">
                    <div className="col-md-12">
                        <span><i>Visualização Emitida <b>{user.nome}</b> no dia {moment().format('DD/MM/YYYY')} às {moment().format('HH:mm:ss')}</i></span>
                    </div>
                </div>
            </ReservaRodapeHash>
        </div> : <></>}
        </div>
    )
}

export default VisualizacaoPadrao
export { tipoGrupo }